import React, {
	Fragment
	, PureComponent
} from 'react';
import { Button } from 'reactstrap';
import { I, webRoot } from '../../../common/v5/config';
import {
	TextInputRow,
	CustomInputRow,
	ReadOnlyTextField,
} from '../../../reactcomponents/Form';
import { LabelToggleSwitch as ToggleSwitch } from '../../../components/v5/ToggleSwitch';
import { Spinner } from '../../../reactcomponents/Spinner';
import { AUTHSERVERURL, INPUT_EMPTY_WARNING, FORM_SUBMIT_EMPTY_WARNING } from '../../../common/v5/constants';
import update from 'immutability-helper';
import { UnnestedAreaSingleSelect } from '../../../reactcomponents/Dropdown';
import { windowPopupCenter } from '../../../common/v5/helpers';

const helperForName = (
	<div>
		<div>{I('This is the name that will be displayed in the list of accounts. This name is only used to help you identify the account.')}</div>
	</div>
);

const helperForArea = (
	<div>
		<div>{I('An area must be chosen because the authenticated Threads account needs to be connected with an area.')}</div>
	</div>
);

const helperForEnable = (
	<div>
		<div>{I('If the account is enabled the system will fetch replies and mentions from Threads.')}</div>
		<div>{I('If it is not enabled the system will not do anything with the account.')}</div>
	</div>
);

const helperForAuthorization = (
	<div>
		<div>{I('Authorize with the Cention Threads application (separate from Facebook/Instagram).')}</div>
		<br />
		<div>{I('Click the Authorize button to start the authorization process.')}</div>
	</div>
);

const threadsOAuthScopes = [
	'threads_basic',
	'threads_content_publish',
	'threads_manage_replies',
	'threads_read_replies',
].join(',');

const ThreadsAuthButton = ({ label, onFetchKey, decryptedAppId }) => {
	const handleClick = () => {
		console.log('[Threads OAuth] decryptedAppId:', JSON.stringify(decryptedAppId));
		const redirectURI = webRoot + 'media/threads/handletoken';
		console.log('[Threads OAuth] redirectURI:', redirectURI);
		const path = 'https://threads.net/oauth/authorize?';
		const queryParameters = [
			'client_id=' + decryptedAppId,
			'redirect_uri=' + encodeURIComponent(redirectURI),
			'response_type=code',
			'scope=' + threadsOAuthScopes,
		];
		const url = path + queryParameters.join('&');
		console.log('[Threads OAuth] full URL:', url);
		if (onFetchKey) {
			onFetchKey();
		}
		windowPopupCenter(url, 400, 580);
	};
	return (
		<Button
			className="btn-outline blue btn-icon-text"
			outline
			color="primary"
			onClick={handleClick}
			title={label}
		>
			<i className={'icon-v5-threads'} />
			<span className="label">{label}</span>
		</Button>
	);
};

export default class AccountThreadsForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			decryptedAppId: '',
			authorizationStr: I('Authorize'),
			showAuthBtn: true,
			pageLoading: false,
			reqInputs: {
				name: { touched: false },
			},
		};
	}

	async decryptData(encryptedData, key) {
		try {
			const standardB64 = encryptedData.replace(/-/g, '+').replace(/_/g, '/');
			const encryptedBytes = Uint8Array.from(atob(standardB64), c => c.charCodeAt(0));
			const iv = encryptedBytes.slice(0, 12);
			const dataToDecrypt = encryptedBytes.slice(12);
			const cryptoKey = await crypto.subtle.importKey(
				'raw',
				new TextEncoder().encode(key),
				{ name: 'AES-GCM' },
				false,
				['decrypt']
			);
			const decrypted = await crypto.subtle.decrypt(
				{ name: 'AES-GCM', iv },
				cryptoKey,
				dataToDecrypt
			);
			return new TextDecoder().decode(decrypted);
		} catch (error) {
			console.error('Threads app id decryption failed', error);
			return null;
		}
	}

	_decryptAppId = (encryptedAppId) => {
		console.log('[Threads] _decryptAppId called, encryptedAppId:', JSON.stringify(encryptedAppId));
		if (!encryptedAppId) {
			console.warn('[Threads] encryptedAppId is empty/falsy, skipping decryption');
			return;
		}
		const decryptionKey = '12345678901234567890123456789012';
		this.decryptData(encryptedAppId, decryptionKey)
			.then(decryptedAppId => {
				console.log('[Threads] decryption result:', JSON.stringify(decryptedAppId));
				if (decryptedAppId) {
					this.setState({ decryptedAppId });
				} else {
					console.warn('[Threads] decryption returned null/empty');
				}
			})
			.catch(error => {
				console.error('[Threads] decryption promise rejected:', error);
			});
	};

	componentDidMount = () => {
		console.log('[Threads] componentDidMount, threadsPageId prop:', JSON.stringify(this.props.threadsPageId));
		this._decryptAppId(this.props.threadsPageId);

		const ds = this.props.input;
		if (typeof ds.id !== 'undefined' && ds.id > 0) {
			this.setState({
				authorizationStr: I('Re-authorize'),
			});
		}
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.threadsPageId !== this.props.threadsPageId) {
			console.log('[Threads] componentDidUpdate, threadsPageId changed:', JSON.stringify(prevProps.threadsPageId), '->', JSON.stringify(this.props.threadsPageId));
			this._decryptAppId(this.props.threadsPageId);
		}
	};

	componentWillUnmount = () => {
		$('body').off('threads.authorization.accounts');
	};

	handleSelectArea = val => {
		this.props.onChangeAdminInput('selectedArea', val, this.props.view);
	};

	handleToggle = (value, field) => {
		this.props.onChangeAdminInput(field, value);
	};

	handleAuth = () => {
		$('body').on('threads.authorization.accounts', function (e, authCode) {
			this.setState({ pageLoading: true });
			const redirectURI = webRoot + 'media/threads/handletoken';
			$.post(webRoot + 'threads/getLongLivedAccessToken', {
				accessToken: authCode,
				redirectUri: redirectURI,
			})
				.done(
					function (results) {
						this.props.onChangeAdminInput('accountID', results.accountID);
						this.props.onChangeAdminInput('accountName', results.accountName);
						this.props.onChangeAdminInput('pageId', results.pageId || results.accountID);
						this.props.onChangeAdminInput('accessToken', results.accessToken);
						this.setState({
							showAuthBtn: false,
							pageLoading: false,
						});
					}.bind(this)
				)
				.fail(function (error) {
					console.log('Error loading data from: threads/getLongLivedAccessToken', error);
					this.setState({ pageLoading: false });
				}.bind(this));
		}.bind(this));
	};

	handleFieldWarning = e => {
		const field = e.target.name;
		let reqInputs = this.state.reqInputs;
		reqInputs = update(reqInputs, {
			[field]: {
				touched: { $set: true },
			},
		});
		this.setState({ reqInputs });
	};

	handleSubmit = e => {
		e.preventDefault();
		let reqInputs = this.state.reqInputs;
		const input = this.props.input;
		let valid = true;

		$.each(reqInputs, (field, v) => {
			reqInputs = update(reqInputs, {
				[field]: {
					touched: { $set: true },
				},
			});
			if (input[field] === '' || input[field] === undefined || input.selectedArea === '0') {
				valid = false;
			}
		});
		this.setState({ reqInputs });
		if (input.accountName === '' || input.accountName === undefined || !input.accessToken) {
			return alert(I('Threads account is not valid. Complete authorization first.'));
		}
		if (valid) {
			this.props.onSave();
		} else {
			alert(FORM_SUBMIT_EMPTY_WARNING);
		}
	};

	render() {
		const { areaList, input, onHandleTextInputChange, hidden, baseButtons } = this.props;

		const selectedArea = parseInt(input.selectedArea, 10);
		const st = this.state;
		const field = st.reqInputs;
		const warnTxt = INPUT_EMPTY_WARNING;

		return (
			<form onSubmit={this.handleSubmit} className="admin-one-form edit-admin-form" hidden={hidden}>
				<CustomInputRow
					id={'area'}
					name={'area'}
					label={I('Area')}
					className={'admin-dropdown-select'}
					mandatory={true}
					helper={helperForArea}
				>
					<UnnestedAreaSingleSelect
						data={areaList}
						invalidSelectedText={I('No selection')}
						onSelect={this.handleSelectArea}
						selected={selectedArea}
						nested={{ key: 'Areas' }}
						idFields={{ id: 'Id', name: 'Name' }}
					/>
				</CustomInputRow>
				<TextInputRow
					id={'name'}
					name={'name'}
					className="admin-text-input"
					label={I('Name')}
					value={input.name || ''}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={!input.name && field.name.touched && warnTxt}
					onBlur={this.handleFieldWarning}
					helperTxt={helperForName}
				/>
				<ToggleSwitch
					id={'enable'}
					name={'enable'}
					data-qa-id="enableThreads"
					label={I('Activated')}
					checked={input.enable}
					onClick={this.handleToggle}
					listWrap={false}
					className="admin-text-input"
					helperTxt={helperForEnable}
				/>
				{st.showAuthBtn && (
					<CustomInputRow
						id={'threadsAuthorization'}
						name={'threadsAuthorization'}
						label={I('Authorization')}
						className={'admin-auth-button'}
						helper={helperForAuthorization}
						mandatory={true}
					>
						<ThreadsAuthButton
							onFetchKey={this.handleAuth}
							label={st.authorizationStr}
							decryptedAppId={st.decryptedAppId}
						/>
					</CustomInputRow>
				)}
				{st.pageLoading ? (
					<div className="center p-3">
						<Spinner />
					</div>
				) : (
					<Fragment>
						<ReadOnlyTextField
							id={'accountID'}
							name={'accountID'}
							className="admin-text-input"
							label={I('Threads account ID')}
							value={input.accountID || ''}
							hidden={!input.accountID}
						/>
						<ReadOnlyTextField
							id={'accountName'}
							name={'accountName'}
							className="admin-text-input"
							label={I('Threads username')}
							value={input.accountName || ''}
							hidden={!input.accountName}
						/>
					</Fragment>
				)}
				{baseButtons}
			</form>
		);
	}
}
